import React from "react";
import { Container } from "reactstrap";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { connect } from 'react-redux';

const Footer = (props) => {
  return (
    <footer className={"footer" + (props.default ? " footer-default" : "")}>
      <Container fluid={props.fluid ? true : false}>
        <ul className="nav">
          <li className="nav-item">
            <NavLink className="nav-link" to={`/privacy`}>
              Privacy policy
            </NavLink>
          </li>{" "}
          <li className="nav-item">
            <NavLink className="nav-link" to={`/tos`}>
            Terms of service
            </NavLink>
          </li>{" "}
          <li className="nav-item">
            <a className="nav-link" href="https://rustlink.io/discord">
              Discord
            </a>
          </li>{" "}
          {props.staff === 1337 && <li className="nav-item">
            <NavLink className="nav-link" to={`/admin`}>
              Admin
            </NavLink>
          </li>}
        </ul>
        <div className="copyright">
          © {new Date().getFullYear()} {" "}
          RustLink.io
        </div>
      </Container>
    </footer>
  );
};

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

const mapDispatchToProps = {
};

const mapStateToProps = (state) => {
  const { staff } = state.infos;
  return { staff };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);